module.exports = __webpack_public_path__ + "static/media/icon-logo-dark.e2c1bc0f.svg";